import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useTheme } from '../contexts/ThemeContext';

const { FiExternalLink, FiCheckCircle, FiCircle } = FiIcons;

const Lesson = ({ lesson, isCompleted, onToggleComplete, isFirst }) => {
  const { isDarkMode } = useTheme();

  const renderContent = () => {
    if (lesson.type === 'video') {
      return (
        <motion.div 
          className="relative w-full h-0 pb-[56.25%] mt-4 rounded-lg overflow-hidden shadow-custom-lg"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <iframe 
            className="absolute top-0 left-0 w-full h-full border-0" 
            src={lesson.videoUrl} 
            allowFullScreen 
          />
        </motion.div>
      );
    } else if (lesson.type === 'link') {
      return (
        <motion.a 
          href={lesson.linkUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-5 py-3 rounded-2xl font-semibold mt-4 hover:shadow-custom-lg transition-all duration-300"
          whileHover={{ y: -2, scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <SafeIcon icon={FiExternalLink} className="text-lg" />
          {lesson.linkText || 'Vai al link'}
        </motion.a>
      );
    }
  };

  return (
    <motion.div 
      className={` p-5 transition-all duration-300 ${isDarkMode ? 'hover:bg-gray-700/50' : 'hover:bg-gray-50'} ${isCompleted && lesson.type !== 'text' ? isDarkMode ? 'bg-gradient-to-r from-transparent via-green-900/20 to-transparent' : 'bg-gradient-to-r from-transparent via-green-50 to-transparent' : ''} ${!isFirst ? isDarkMode ? 'border-t border-gray-600' : 'border-t border-gray-200' : ''} `}
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3 }}
      whileHover={{ x: 5 }}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-3">
        <motion.h4 
          className={`font-bold text-lg transition-colors duration-300 ${isDarkMode ? 'text-white' : 'text-gray-700'}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          {lesson.title}
        </motion.h4>
        
        {lesson.type !== 'text' && (
          <div className="flex items-center gap-3">
            <motion.div 
              animate={{ scale: isCompleted ? [1, 1.2, 1] : 1, rotate: isCompleted ? [0, 10, -10, 0] : 0 }} 
              transition={{ duration: 0.5 }}
            >
              <SafeIcon icon={isCompleted ? FiCheckCircle : FiCircle} className={`text-xl transition-colors duration-300 ${isCompleted ? 'text-green-500' : isDarkMode ? 'text-gray-400' : 'text-gray-400'}`} />
            </motion.div>
            <motion.button 
              className={` px-4 py-2 rounded-2xl font-semibold text-sm transition-all duration-300 ${isCompleted ? 'bg-green-600 text-white hover:bg-green-700' : 'bg-green-500 text-white hover:bg-green-600 hover:shadow-custom-md'} `}
              onClick={onToggleComplete}
              whileHover={{ y: -1, scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {isCompleted ? '✅ Completata' : 'Segna come completata'}
            </motion.button>
          </div>
        )}
      </div>
      {renderContent()}
    </motion.div>
  );
};

export default Lesson;